export const heroOptions = {
  autoPlay: true,

  fullScreen: {
    enable: false,
    zIndex: 0,
  },

  detectRetina: true,
  fpsLimit: 120,

  interactivity: {
    detectsOn: '#hero',
    events: {
      onDiv: [
        {
          selectors: '#repulse-div',
          enable: true,
          mode: 'bounce',
          type: 'circle',
        },
        {
          selectors: '#repulse-div',
          enable: true,
          mode: 'repulse',
          type: 'circle',
        },
        {
          selectors: '#repulse-span',
          enable: true,
          mode: 'repulse',
          type: 'circle',
        },
        {
          selectors: '#repulse-span',
          enable: true,
          mode: 'bounce',
          type: 'circle',
        },
        {
          selectors: '#togglebutton',
          enable: true,
          mode: 'repulse',
          type: 'circle',
        },
        {
          selectors: '#togglebutton',
          enable: true,
          mode: 'bounce',
          type: 'circle',
        },
        {
          selectors: '#scroller',
          enable: true,
          mode: 'repulse',
          type: 'circle',
        },
        {
          selectors: '#scroller',
          enable: true,
          mode: 'bounce',
          type: 'circle',
        },
      ],

      onHover: {
        enable: true,
        mode: 'bubble',
        parallax: {
          enable: true,
          force: 350,
          smooth: 200,
        },
      },
      resize: {
        delay: 0.5,
        enable: true,
      },
    },

    modes: {
      bounce: {
        distance: 100,
      },
      bubble: {
        distance: 100,
        duration: 0.4,
        size: 40,
        color: {
          value: '#63759d',
        },
        opacity: 8,
        mix: false,
      },

      repulse: {
        distance: 200,
        factor: 200,
        speed: 1,
        maxSpeed: 50,
      },
    },
  },

  particles: {
    collisions: {
      enable: true,
      mode: 'bounce',
    },
    color: {
      value: '#94afea',
    },
    move: {
      angle: {
        offset: 0,
        value: 90,
      },
      center: {
        x: 50,
        y: 50,
        mode: 'percent',
        radius: 0,
      },
      direction: ['top-left', 'bottom-left', 'bottom-right', 'top-right'],
      drift: 0,
      enable: true,
      random: false,
      size: false,
      speed: 0.8,
      outMode: 'bounce',
    },
    number: {
      limit: 0,
      value: 50,
    },

    opacity: {
      random: {
        enable: true,
        minimumValue: 0.4,
        maxValue: 0.6,
      },
      value: 0.6,
      animation: {
        count: 0,
        enable: true,
        speed: 0.2,
        decay: 0,
        sync: true,
        destroy: 'none',
        startValue: 'random',
      },
    },

    shape: {
      // type: ['image', 'character'],
      type: ['character'],
      character: [
        {
          fill: true,
          font: 'FontAwesome',
          weight: '900', // solid
          value: ['\uf030', '\uf11b', '\uf108', '\uf06d'], // solid icons
        },
        {
          fill: true,
          font: 'FontAwesome',
          weight: '400', // regular
          value: ['\uf441', '\uf447', '\uf445', '\uf001'], // regular icons
        },
      ],
      // image: [
      //   {
      //     src: '/RicardoPic.jpg',
      //     width: 32,
      //     height: 32,
      //   },
      //   {
      //     src: '/Photos/cake.JPG',
      //     width: 32,
      //     height: 32,
      //   },
      //   {
      //     src: '/images/photo3.png',
      //     width: 32,
      //     height: 32,
      //   },
      // ],
    },


    size: {
      random: {
        enable: true,
        minimumValue: 25,
        maxValue: 35,
      },
      animation: {
        count: 0,
        enable: true,
        speed: 0.2,
        decay: 0,
        sync: true,
        destroy: 'none',
        startValue: 'random',
      },
    },

    // lineLinked: {
    //   blink: false,
    //   color: {
    //     value: '#000000',
    //   },
    //   consent: true,
    //   distance: 100,
    //   enable: true,
    //   frequency: 10,
    //   opacity: 0.4,
    //   width: 1,
    // },
  },
  pauseOnBlur: true,
  pauseOnOutsideViewport: true,
  smooth: true,
};